export enum ProductSetType {
    UserDefined = 0,
    System      = 1
}

export enum ProductSetListType{
    WhiteList = 0,
    BlackList = 1
}